import React, { FC, useCallback, useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { data, stateData } from './ActivityTableLists'
import { TableSmall } from '../../../../../../components/Dashboard/TableSmall'
import { useRest } from '../../../../../../components/Context'
import { GreenButton } from '../../../../../../components/Dashboard/Buttons/GreenButton'
import { MemoFundAccountPopup } from '../FundAccountPopup'

const useStyles = makeStyles((theme: Theme) => ({
  formWrap: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    paddingTop: theme.spacing(4),
  },
  container: {
    minHeight: 40,
    maxHeight: 40,
  },
  sectionWrap: {
    width: '100%',
    height: '100%',
    padding: theme.spacing(0, 4, 4, 4),
  },
  buttonsWrap: {
    margin: theme.spacing(-1),
  },
  button: {
    paddingBottom: theme.spacing(4),
  },
}))

interface ActivitySectionProps {
  title?: string
}

export const Activity: FC<ActivitySectionProps> = ({ title }) => {
  const classes = useStyles()

  const formMethods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldFocusError: true,
  })

  const { rxiosAuth } = useRest()

  // eslint-disable-next-line
  const [loading, setLoading] = useState<boolean>(false)
  // eslint-disable-next-line
  const [values, setValues] = useState<any>({})
  const [isOpenModal, setOpenModal] = useState<boolean>(false)

  const openModal = useCallback(() => {
    setOpenModal((prevState) => !prevState)
  }, [setOpenModal])

  const closeModal = useCallback(() => {
    setOpenModal(false)
  }, [setOpenModal])

  const loadData = useCallback(async () => {
    let cleanupFunction = false
    setLoading(true)

    rxiosAuth.get(data.request).subscribe(
      // eslint-disable-next-line
      (next: any) => {
        setValues(next)
        if (!cleanupFunction) setLoading(false)
      },
      (error) => {
        toast.error(error)
        setLoading(false)
      },
      () => {
        setLoading(false)
      },
    )
    cleanupFunction = true
    // eslint-disable-next-line
  }, [rxiosAuth])

  useEffect(() => {
    ;(async () => {
      // await loadData()
    })()
  }, [loadData])

  return (
    <>
      <Grid item xs={12} className={classes.formWrap}>
        <FormProvider {...formMethods}>
          <Grid item xs={12} className={classes.container}>
            {title ? <Typography variant={'h6'}>{title}</Typography> : ' '}
          </Grid>
          <Grid item xs={12} className={classes.sectionWrap}>
            <TableSmall
              columns={data.columns}
              // data={values.backets}
              data={stateData}
              pb={16}
              loading={loading}
            />

            <Grid container spacing={2} className={classes.buttonsWrap}>
              <Grid item xs={6} className={classes.button}>
                <GreenButton text={'Fund Account'} width={'100%'} onClick={openModal} />
              </Grid>
            </Grid>
          </Grid>
        </FormProvider>
      </Grid>

      <MemoFundAccountPopup isOpen={isOpenModal} modalClose={closeModal} />
    </>
  )
}
